/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as CircleCommunityPageLoader } from './CircleCommunityPage/CircleCommunityPage.duck';
import { loadData as CartPageLoader } from './CartPage/CartPage.duck';
import { loadData as SignUpStepsPageLoader } from './SignUpStepsPage/SignUpStepsPage.duck';
import { loadData as StripeSubscriptionPageLoader } from './StripeSubscriptionPage/StripeSubscriptionPage.duck';
import { loadData as DiscountsLandingPageLoader } from './DiscountsLandingPage/DiscountsLandingPage.duck';
import { loadData as JoinedCommunityGroupsPageLoader } from './JoinedGroupsCommunityPage/JoinedGroupsCommunityPage.duck';
import { loadData as DiscoverGroupsCommunityPageLoader } from './DiscoverGroupsCommunityPage/DiscoverGroupsCommunityPage.duck';
import { loadData as MyGroupCommunityPageLoader } from './MyGroupCommunityPage/MyGroupCommunityPage.duck';
import { loadData as MyGroupCommunityPageForUnknownUserLoader } from './MyGroupCommunityPageForUnknownUser/MyGroupCommunityPageForUnknownUser.duck';
import { loadData as GroupSearchPageLoader } from './GroupSearchPage/GroupSearchPage.duck';
import { loadData as ShippingInfoPageLoader } from './ShippingInfoPage/ShippingInfoPage.duck';
import { loadData as AdminPanelSupabasePageLoader } from './AdminPanelSupabasePage/AdminPanelSupabasePage.duck';
import { loadData as AiChatBotPageLoader } from './AiChatBotPage/AiChatBotPage.duck';
import { loadData as RuleBooksSearchPageLoader } from './RuleBooksSearchPage/RuleBooksSearchPage.duck';

import { loadData as YouthAccountSettingsPageLoader } from './YouthAccountSettingsPage/YouthAccountSettingsPage.duck';
import { loadData as PostViewPageLoader } from './PostViewPage/PostViewPage.duck';
import { loadData as AdminPanelOrganisationPageLoader } from './AdminPanelOrganisationPage/AdminPanelOrganisationPage.duck';
import { loadData as AdminPanelChatHistoryPageLoader } from './AdminPanelChatHistoryPage/AdminPanelChatHistoryPage.duck';
import { loadData as AdminPanelWalletPageLoader } from './AdminPanelWalletPage/AdminPanelWalletPage.duck';
import { loadData as AdminPanelShopifyFeeReportPageLoader } from './AdminPanelShopifyFeeReportPage/AdminPanelShopifyFeeReportPage.duck';
import { loadData as AdminPanelModeratorsPageLoader } from './AdminPanelModeratorsPage/AdminPanelModeratorsPage.duck';
import { loadData as AdminPanelCategoryPageLoader } from './AdminPanelCategoryPage/AdminPanelCategoryPage.duck';
import { loadData as AdminPanelDiscountCodesPageLoader } from './AdminPanelDiscountCodesPage/AdminPanelDiscountCodesPage.duck';
import { loadData as AdminPanelDailyDealsPageLoader } from './AdminPanelDailyDealsPage/AdminPanelDailyDealsPage.duck';
import { loadData as AdminPanelHighlightsPageLoader } from './AdminPanelHighlightsPage/AdminPanelHighlightsPage.duck';
import { loadData as AdminPanelDiscoverGroupsCarouselsPageLoader } from './AdminPanelDiscoverGroupsCarouselsPage/AdminPanelDiscoverGroupsCarouselsPage.duck';
import { loadData as AdminPanelSubscriptionsPageLoader } from './AdminPanelSubscriptionsPage/AdminPanelSubscriptionsPage.duck';
import { loadData as SubscriptionCheckoutPageLoader } from './SubscriptionCheckoutPage/SubscriptionCheckoutPage.duck';
import { loadData as GroupPaymentHistoryPageLoader } from './GroupPaymentHistoryPage/GroupPaymentHistoryPage.duck';
import { loadData as AdminPanelUserPageLoader } from './AdminPanelUserPage/AdminPanelUserPage.duck';
import { loadData as ShopifyOnboardingPageLoader } from '../ducks/ShopifyOnboardingPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    AdminPanelOrganisationPage: {
      loadData: AdminPanelOrganisationPageLoader,
    },
    AdminPanelWalletPage: {
      loadData: AdminPanelWalletPageLoader,
    },
    AdminPanelShopifyFeeReportPage: {
      loadData: AdminPanelShopifyFeeReportPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CartPage: {
      loadData: CartPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    CircleCommunityPage: {
      loadData: CircleCommunityPageLoader,
    },
    SignUpStepsPage: {
      loadData: SignUpStepsPageLoader,
    },
    StripeSubscriptionPage: {
      loadData: StripeSubscriptionPageLoader,
    },
    DiscountsLandingPage: {
      loadData: DiscountsLandingPageLoader,
    },
    JoinedCommunityGroupsPage: {
      loadData: JoinedCommunityGroupsPageLoader,
    },
    DiscoverGroupsCommunityPage: {
      loadData: DiscoverGroupsCommunityPageLoader,
    },
    MyGroupCommunityPage: {
      loadData: MyGroupCommunityPageLoader,
    },
    MyGroupCommunityPageForUnknownUser: {
      loadData: MyGroupCommunityPageForUnknownUserLoader,
    },
    GroupSearchPage: {
      loadData: GroupSearchPageLoader,
    },
    ShippingInfoPage: {
      loadData: ShippingInfoPageLoader,
    },
    AdminPanelSupabasePage: {
      loadData: AdminPanelSupabasePageLoader,
    },
    AiChatBotPage: {
      loadData: AiChatBotPageLoader,
    },
    RuleBooksSearchPage: {
      loadData: RuleBooksSearchPageLoader,
    },
    FavouritePage: {
      loadData: RuleBooksSearchPageLoader,
    },
    YouthAccountSettingsPage: {
      loadData: YouthAccountSettingsPageLoader,
    },
    PostViewPage: {
      loadData: PostViewPageLoader,
    },
    AdminPanelChatHistoryPage: {
      loadData: AdminPanelChatHistoryPageLoader,
    },
    AdminPanelModeratorsPage: {
      loadData: AdminPanelModeratorsPageLoader,
    },
    AdminPanelCategoryPage: {
      loadData: AdminPanelCategoryPageLoader,
    },
    AdminPanelDiscountCodesPage: {
      loadData: AdminPanelDiscountCodesPageLoader,
    },
    AdminPanelDailyDealsPage: {
      loadData: AdminPanelDailyDealsPageLoader,
    },
    AdminPanelHighlightsPage: {
      loadData: AdminPanelHighlightsPageLoader,
    },
    AdminPanelDiscoverGroupsCarouselsPage: {
      loadData: AdminPanelDiscoverGroupsCarouselsPageLoader,
    },
    AdminPanelSubscriptionsPage: {
      loadData: AdminPanelSubscriptionsPageLoader,
    },
    SubscriptionCheckoutPage: {
      loadData: SubscriptionCheckoutPageLoader,
    },
    GroupPaymentHistoryPage: {
      loadData: GroupPaymentHistoryPageLoader,
    },
    AdminPanelUserPage: {
      loadData: AdminPanelUserPageLoader,
    },
    ShopifyOnboardingPage: {
      loadData: ShopifyOnboardingPageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
